import { ICategories } from "@/interfaces/assessments/ICategories";
import {
  addItemFromMaster,
  checklistProcessFileDataBeforeSort,
  deleteFiles,
  generateCheklistStatusIdToChecklistStatusName,
  getAllChecklist,
  getAssessmentCategories,
  getAssessmentChecklists,
  getChecklist,
  getChecklistAll,
  getChecklistAssessmentScore,
  getCheckListIdMetricsCompletion,
  getCheckListIdMetricsCountCompliance,
  getCheckListStatusDetails,
  getCostAssessment,
  getDetailFromCheckListId,
  getEffortAssessment,
  getImpactAssessment,
  getImportanceAssessment,
  getInputComplianceTypes,
  getMetricFromChecklistId,
  getTemplate,
  getTemplateDetail,
  getUserUploadFile,
  handleGetAttachment,
  initialChecklistByCategory,
  initialChecklistMaster,
  initialChecklistOrigin,
  postChecklistTemplate,
  processChecklistAssessmentData,
  putChecklistRename,
  putChecklistStatus,
  putChecklistTemplate,
  updateChecklistAnswer,
} from "@/services/assessment";
import userService from "@/services/user/userService";
import get from "lodash/get";
import { Module } from "vuex";
import store, { RootState } from "..";
import {
  IAssessmentChecklistByCategory,
  IAssessmentChecklistItem,
  IAssessmentDetail,
  IAssessmentOverview,
  IAssessmentQuestionTable,
  IAssessmentStore,
  IChecklistInfoDetail,
  IChecklistMetricsCompletion,
  IRecentSearch,
} from "@/interfaces/assessments/IAssessmentDetails";
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  assessmentStatus,
  assessmentViews,
  CHECKLIST_TYPE,
  checklistStatusId,
  localStorageKey,
  successStatusCodes,
} from "@/utils/constants";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Assessment, Checklist, UserRoute } from "@/services/apiRoutes/routes";
import utilities, { getComponentUiText } from "@/utils/utilities";
import cloneDeep from "lodash/cloneDeep";
import { getChecklistGroupTemplateMetrics } from "@/services/recommend";
import { decryptFileBase64 } from "@/utils/cipher";
import {
  getRequestAssessmentAttachment,
  getRequestVendorAssessmentAttachment,
} from "@/services/vendor";

const assessmentModule: Module<IAssessmentStore, RootState> = {
  namespaced: true,
  state() {
    return {
      filters: [],
      loading: true,
      checklistUpdateType: "",
      loadingSearch: true,
      objectChecklistOrigin: {} as IAssessmentChecklistByCategory,
      arrayChecklistOrigin: [] as IAssessmentChecklistItem[],
      arrayChecklistAllOrigin: [] as IAssessmentChecklistItem[],
      categories: [] as ICategories[],
      activeCategory: "",
      reFreshCategory: false,
      currentChecklistId: 0,
      assessmentQuestionTypes: [],
      assessmentQuestionTypesClr: [],
      checklistAll: [],
      checklistDetail: {},
      checklistMetricsCompletion: {},
      checklistInforDetail: {},
      isHideComplete: false,
      getIsShowExcluded: false,
      showMasterItems: false,
      listTemplate: [],
      assessmentView: assessmentViews.default,
      checklistAssessment: [],
      assessmentHistory: [] as IAssessmentDetail[],
      importanceAssessment: [],
      impactAssessment: [],
      costAssessment: [],
      effortAssessment: [],
      scoreDetail: [],
      overviewCardData: {
        detailsCard: {
          id: 0,
          checklistCreatedDate: "",
          checklistLastUpdatedDate: "",
          checklistStatus: assessmentStatus.inProgress,
        },
        exposuresCard: {
          criticalNumber: 0,
          totalNumber: 0,
        },
        completionCard: {
          checklistCompletion: 0,
          checklistCompletionMax: 0,
          checklistCompletionPcnt: 0,

          checklistScore: 0,
          checklistScoreMax: 0,
          checklistScorePcnt: 0,
        },
        contributorsCard: {
          checklistId: 0,
        },
      } as IAssessmentOverview,
      recommendations: 0,
      listRecentSearches: {} as IRecentSearch,
      listTemplateDetail: [],
      currentChecklistAdvanced: {},
    };
  },

  getters: {
    getCategoriesDetails: (state) => state.categories,

    getChecklistUpdateType: (state) => state.checklistUpdateType,

    getFilters: (state) => state.filters,

    getChecklistActive: (state) =>
      state.objectChecklistOrigin[state.activeCategory] || [],

    getChecklistOriginByCategory: (state) => {
      return state.arrayChecklistOrigin.filter(
        (item) => item.checklistItemCategoryId === state.activeCategory,
      );
    },

    getCurrentChecklistId: (state) => state.currentChecklistId,

    getAssessmentQuestionTypes: (state) => state.assessmentQuestionTypes,
    getChecklistAll: (state) => state.checklistAll || [],
    getChecklistAllForSearchBox: (state) => {
      const loop = (
        array: IAssessmentQuestionTable[],
        parent?: IAssessmentQuestionTable,
      ) => {
        const output: IAssessmentQuestionTable[] = [];
        for (const item of array) {
          item.id = item.checklistItemId;
          if (parent) {
            const subCategory =
              parent.checklistItemHeadingLabel ||
              parent.checklistItemName ||
              "";
            if (
              parent.checklistItem2ndSubCategoryLabel ||
              parent.checklistItem3ndSubCategoryLabel
            ) {
              item.checklistItem2ndSubCategoryLabel = [
                ...(parent.checklistItem2ndSubCategoryLabel || []),
                ...(parent.checklistItem3ndSubCategoryLabel || []),
              ];
              item.checklistItem3ndSubCategoryLabel = [subCategory];
            } else {
              item.checklistItem2ndSubCategoryLabel = [subCategory];
            }
          }
          if (item.checklistChildren) {
            item.checklistChildren = loop(
              item.checklistChildren as IAssessmentQuestionTable[],
              item,
            );
          }
          output.push(item);
        }
        return output;
      };
      const pruneParent = (
        array: IAssessmentQuestionTable[],
        orderNumber = 0,
      ) => {
        const output: IAssessmentQuestionTable[] = [];
        array?.forEach((item) => {
          if (item.checklistChildren) {
            item.checklistChildren?.forEach((child) => {
              child.orderNumber = `${++orderNumber}`;
              output.push(child as IAssessmentQuestionTable);
            });
          } else {
            output.push(item as IAssessmentQuestionTable);
          }
        });
        return output;
      };
      const reOrder = (
        array?: IAssessmentQuestionTable[],
        parentOrderNumber?: string,
      ) => {
        array?.forEach((item, index) => {
          if (parentOrderNumber) {
            item.orderNumber = `${parentOrderNumber}.${index + 1}`;
          }
          reOrder(
            item.checklistChildren as IAssessmentQuestionTable[],
            item.orderNumber,
          );
        });
      };

      let checklistAssessmentQuestions = loop(
        state.checklistAll as IAssessmentQuestionTable[],
      );
      checklistAssessmentQuestions = pruneParent(checklistAssessmentQuestions);
      reOrder(checklistAssessmentQuestions);
      return checklistAssessmentQuestions;
    },
    getChecklistItemCurrentAll: (state) => (checklistItemId: number) => {
      const item = state.arrayChecklistAllOrigin.find(
        (item) => item.checklistItemId === checklistItemId,
      );
      if (item) return item;
      else return {};
    },

    getChecklistDetail: (state) => state.checklistDetail,

    getCurrentChecklistItem:
      (state) =>
      (checklistItemId: number, isGlobalSearch = false) => {
        const dataSrc = isGlobalSearch
          ? state.arrayChecklistAllOrigin
          : state.arrayChecklistOrigin;
        const item = dataSrc.find(
          (item) => item.checklistItemId === checklistItemId,
        );
        if (item) return item;
        else return {};
      },

    getChecklistMetricsCompletion: (state) => state.checklistMetricsCompletion,

    getChecklistInforDetail: (state) => state.checklistInforDetail,
    getChecklistInforDetailById: (state) => (checklistId: number) => {
      let data;
      state.checklistAssessment.forEach((item) => {
        if (item.checklistId === checklistId) data = item;
        else {
          item.checklistItem &&
            item.checklistItem.forEach((itemCl) => {
              if (itemCl.checklistId === checklistId) data = itemCl;
            });
        }
      });
      if (data) return data;
      else return {};
    },
    getIsShowExcluded: (state) => state.getIsShowExcluded,
    getIsHideComplete: (state) => state.isHideComplete,
    getShowMasterItems: (state) => state.showMasterItems,
    getAssessmentView: (state) => state.assessmentView,

    getDropDownAnswerData: (state) => (questionType: string) => {
      const data = state.assessmentQuestionTypes.find(
        (item) => item.id === questionType,
      );
      if (data) return data.complianceTypeValues;
      else return null;
    },

    getChecklistAssessment: (state) => state.checklistAssessment,
    getImportanceAssessment: (state) => state.importanceAssessment,
    getImpactAssessment: (state) => state.impactAssessment,
    getEffortAssessment: (state) => state.effortAssessment,
    getCostAssessment: (state) => state.costAssessment,
    getRecommendations: (state) => state.recommendations,
    getActiveCategory: (state) => state.activeCategory,
    getRecentSearch: (state) => (searchTypeId) => {
      return state.listRecentSearches[searchTypeId]?.searchHistory || [];
    },
    getListTemplateDetail: (state) => state.listTemplateDetail,
    getScoreDetail: (state) => (checklistItemId: number) => {
      return state.scoreDetail?.find(
        (item) => item.checklistId === checklistItemId,
      );
    },
  },

  mutations: {
    INITIALISE: (state: any) => {
      const localIsHideCompleteValue = localStorage.getItem(
        localStorageKey.isHideComplete,
      );
      state.isHideComplete =
        localIsHideCompleteValue &&
        localIsHideCompleteValue.toLowerCase() === "true"
          ? true
          : false;
      const isShowExcluded = JSON.parse(
        localStorage.getItem(localStorageKey.isShowExcluded) || "false",
      );
      state.getIsShowExcluded = isShowExcluded;
      const localShowMasterItemsValue = localStorage.getItem(
        localStorageKey.showMasterItems,
      );
      state.showMasterItems =
        localShowMasterItemsValue &&
        localShowMasterItemsValue.toLowerCase() === "true"
          ? true
          : false;

      const localAssessmentViewValue = localStorage.getItem(
        localStorageKey.assessmentView,
      );
      if (localAssessmentViewValue)
        state.assessmentView = localAssessmentViewValue;
      else state.assessmentView = assessmentViews.default;
    },
    INITIAL_CHANGE_ORG_USER: (state: any) => {
      // Reset assessment state when changing org or login user.
      state.checklistAssessment = [];
    },
    SET_CURRENT_CATEGORY: (state, category) => {
      state.categories = category;
    },

    SET_LIST_TEMPLATE: (state, listTemplate) => {
      state.listTemplate = listTemplate;
    },

    SET_CURRENT_ACTIVE_CATEGORY: (state, category) => {
      state.activeCategory = category;
    },

    SET_REFRESH_CATEGORY: (state, param) => {
      state.reFreshCategory = param;
    },

    UPDATE_DELETE_CHECKLIST_TEMPLATE: (state, idTemplates: number[]) => {
      state.listTemplate = state.listTemplate.filter(
        (item) => !idTemplates.includes(item.templateId),
      );
    },

    SET_CHECKLIST_CATEGORY: (state, { checklist, category }) => {
      state.objectChecklistOrigin[category] = checklist;

      if (
        state.objectChecklistOrigin[state.activeCategory] &&
        state.objectChecklistOrigin[state.activeCategory].length
      ) {
        state.loading = false;
      } else state.loading = true;
    },
    SET_CHECKLIST_DETAIL: (state, payload) => {
      state.checklistDetail = payload;
    },

    SET_CHECKLIST_ORIGIN: (
      state,
      { checklistUpdated, isForceUpdate, itemRemoved },
    ) => {
      if (isForceUpdate) {
        state.arrayChecklistOrigin = checklistUpdated;
        return;
      }
      let checklistOrigin = state.arrayChecklistOrigin;
      if (itemRemoved) {
        checklistOrigin = checklistOrigin.filter(
          (item) => item.checklistItemId !== itemRemoved,
        );
      }
      const objectChecklistIds = checklistOrigin.reduce((result, item) => {
        result[item.checklistItemId] = true;
        return result;
      }, {});

      checklistUpdated?.forEach((item) => {
        if (!(item.checklistItemId in objectChecklistIds))
          checklistOrigin.push(item);
      });

      state.arrayChecklistOrigin = checklistOrigin;
    },

    SET_CHECKLIST_ALL_ORIGIN: (
      state,
      checklist: IAssessmentChecklistItem[],
    ) => {
      const checklistOrigin = state.arrayChecklistAllOrigin;
      const objectChecklistIds = checklistOrigin.reduce((result, item) => {
        result[item.checklistItemId] = true;
        return result;
      }, {});

      checklist.forEach((item) => {
        if (!(item.checklistItemId in objectChecklistIds))
          checklistOrigin.push(item);
      });

      state.arrayChecklistAllOrigin = checklistOrigin;
    },

    SET_CHECKLIST_ALL: (state, payload) => {
      state.checklistAll = payload;
    },

    UPDATE_CHECKLIST_ITEM: (
      state,
      {
        checklistItemId,
        data,
        type = ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_ATTACHMENTS,
      },
    ) => {
      let checklistItem = state.arrayChecklistOrigin.find(
        (item) => item.checklistItemId === checklistItemId,
      );
      let checklistAll = state.arrayChecklistAllOrigin.find(
        (item) => item.checklistItemId === checklistItemId,
      );
      if (checklistItem) {
        checklistItem[type] = data;
        if (type == ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_ATTACHMENTS)
          checklistItem = checklistProcessFileDataBeforeSort(checklistItem);
      } else return checklistItem;

      if (checklistAll) {
        checklistAll[type] = data;
        if (type == ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_ATTACHMENTS)
          checklistAll = checklistProcessFileDataBeforeSort(checklistAll);
      } else return checklistAll;
    },
    UPDATE_LIST_CHECKLIST_ITEMS: (state, payload) => {
      const { checklistId, checklistItems } = payload;
      checklistItems?.forEach(
        (itemUpdate: Partial<IAssessmentChecklistItem>) => {
          state.arrayChecklistOrigin.some((item, index) => {
            if (item.checklistItemId === itemUpdate.checklistItemId) {
              const itemCompleteValue =
                itemUpdate.checklistItemCompensatingControlValue ||
                itemUpdate.checklistItemCompensatingControlValue === 0
                  ? Number(itemUpdate.checklistItemCompensatingControlValue) *
                    100
                  : itemUpdate.checklistItemComplianceOverride ||
                      itemUpdate.checklistItemComplianceOverride === 0
                    ? Number(itemUpdate.checklistItemComplianceOverride) * 100
                    : undefined;
              state.arrayChecklistOrigin[index] = {
                ...item,
                ...itemUpdate,
                itemCompleteValue,
              };
              return true;
            }
            return false;
          });
          state.arrayChecklistAllOrigin.some((item, index) => {
            if (item.checklistItemId === itemUpdate.checklistItemId) {
              const itemCompleteValue =
                itemUpdate.checklistItemCompensatingControlValue ||
                itemUpdate.checklistItemCompensatingControlValue === 0
                  ? Number(itemUpdate.checklistItemCompensatingControlValue) *
                    100
                  : itemUpdate.checklistItemComplianceOverride ||
                      itemUpdate.checklistItemComplianceOverride === 0
                    ? Number(itemUpdate.checklistItemComplianceOverride) * 100
                    : undefined;
              state.arrayChecklistAllOrigin[index] = {
                ...item,
                ...itemUpdate,
                itemCompleteValue,
              };
              return true;
            }
            return false;
          });
        },
      );

      store.dispatch("Assessment/updateChecklstAllItem", checklistItems);
      const categories = state.categories;
      const array = cloneDeep(state.arrayChecklistOrigin).filter((item) => {
        if (item.checklistItemCategoryId === state.activeCategory) {
          item.checklistChildren = [];
          return true;
        }
        return false;
      });
      const currentOrg = store.state.Org.currentOrg;
      const orgSetup = store.state.SetupWizard.questions[currentOrg.id];
      state.objectChecklistOrigin[state.activeCategory] =
        initialChecklistByCategory(array, categories, orgSetup);

      store.dispatch("Assessment/fetchCategories", {
        checklistId,
        reload: false,
      });
      store.dispatch(
        "Assessment/getCheckListIdMetricsCountCompliance",
        checklistId,
      );
      store.dispatch("Assessment/getCheckListOverviewDetailCard", checklistId);
      store.dispatch(
        "Assessment/getChecklistMetricScoreCompletion",
        checklistId,
      );
      store.dispatch(
        "Assessment/fetchCheckListIdMetricsCompletion",
        checklistId,
      );
      store.dispatch("Assessment/fetchInfoDetailByChecklistId", checklistId);
    },
    UPDATE_CHECKLIST_ITEMS: (
      state,
      {
        checklistItemIds,
        data,
        type = ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_ATTACHMENTS,
      },
    ) => {
      checklistItemIds.forEach((checklistItemId) => {
        let checklistItem = state.arrayChecklistOrigin.find(
          (item) => item.checklistItemId === checklistItemId,
        );
        let checklistAll = state.arrayChecklistAllOrigin.find(
          (item) => item.checklistItemId === checklistItemId,
        );
        if (checklistItem) {
          checklistItem[type] = data;
          if (type == ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_ATTACHMENTS)
            checklistItem = checklistProcessFileDataBeforeSort(checklistItem);
          else if (type == ASSESSMENT_ANSWER_STORE_TYPE.EXCLUDE_ITEM) {
            checklistItem.checklistItemIsExcluded =
              !checklistItem.checklistItemIsExcluded;
            checklistItem.visibleState = checklistItem.checklistItemIsExcluded
              ? "No"
              : "Yes";
          }
        } else return checklistItem;

        if (checklistAll) {
          checklistAll[type] = data;
          if (type == ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_ATTACHMENTS)
            checklistAll = checklistProcessFileDataBeforeSort(checklistAll);
          else if (type == ASSESSMENT_ANSWER_STORE_TYPE.EXCLUDE_ITEM) {
            checklistAll.checklistItemIsExcluded =
              !checklistAll.checklistItemIsExcluded;
            checklistAll.visibleState = checklistAll.checklistItemIsExcluded
              ? "No"
              : "Yes";
          }
        } else return checklistAll;
      });
      store.dispatch("Assessment/fetchCategories", {
        checklistId: state.currentChecklistId,
        reload: false,
      });

      store.dispatch(
        "Assessment/getCheckListIdMetricsCountCompliance",
        state.currentChecklistId,
      );

      store.dispatch(
        "Assessment/getCheckListOverviewDetailCard",
        state.currentChecklistId,
      );

      store.dispatch(
        "Assessment/getChecklistMetricScoreCompletion",
        state.currentChecklistId,
      );

      store.dispatch(
        "Assessment/fetchCheckListIdMetricsCompletion",
        state.currentChecklistId,
      );

      const categories = state.categories;
      const array = cloneDeep(state.arrayChecklistOrigin).filter((item) => {
        if (item.checklistItemCategoryId === state.activeCategory) {
          item.checklistChildren = [];
          return true;
        }
        return false;
      });
      const map = new Map();
      array.forEach((obj) => {
        map.set(obj.itemMasterId, obj);
      });
      const result = Array.from(map.values());
      const currentOrg = store.getters["Organisation/getCurrentOrg"];
      const orgSetup = store.state.SetupWizard.questions[currentOrg.id];
      const checklistSorted = initialChecklistByCategory(
        result,
        categories,
        orgSetup,
      );
      const checklistUpdated = initialChecklistOrigin(result, checklistSorted);
      state.arrayChecklistOrigin = checklistUpdated;
      state.objectChecklistOrigin[state.activeCategory] = checklistSorted;
    },

    UPDATE_CHECKLIST_ALL_ITEM: (state, itemUpdate) => {
      state.arrayChecklistAllOrigin.some((item, index) => {
        if (item.checklistItemId === itemUpdate.checklistItemId) {
          state.arrayChecklistAllOrigin[index] = {
            ...item,
            ...itemUpdate,
          };
          return true;
        }
        return false;
      });
    },
    SET_CURRENT_CHECKLIST_ID: (state, checklistId) => {
      state.currentChecklistId = checklistId;
    },

    SET_ASS_QUES_TYPES: (state: any, list: Array<any>) => {
      state.assessmentQuestionTypes = list;
    },

    SET_ASS_QUES_TYPES_CLR: (state: any, list: Array<any>) => {
      state.assessmentQuestionTypesClr = list;
    },

    SET_CHECKLIST_METRICS_COMPLETION: (state, payload) => {
      state.checklistMetricsCompletion = payload;
    },

    SET_CHECKLIST_INFO_DETAIL: (state, payload) => {
      payload.checklistStatusName =
        generateCheklistStatusIdToChecklistStatusName(
          payload.checklistStatusId,
        );

      state.checklistInforDetail = payload;
    },

    SET_IS_HIDE_COMPLETE: (state: any, isHideComplete: boolean) => {
      localStorage.setItem(
        localStorageKey.isHideComplete,
        isHideComplete.toString(),
      );
      state.isHideComplete = isHideComplete;
    },
    SET_SHOW_MASTER_ITEMS: (state: any, showMasterItems: boolean) => {
      localStorage.setItem(
        localStorageKey.showMasterItems,
        showMasterItems.toString(),
      );
      state.showMasterItems = showMasterItems;
    },
    SET_ASSESSMENT_VIEW: (state: any, assessmentView: boolean) => {
      localStorage.setItem(
        localStorageKey.assessmentView,
        assessmentView.toString(),
      );
      state.assessmentView = assessmentView;
    },
    SET_CHECKLIST_ASSESSMENT: (state: any, payload) => {
      state.checklistAssessment = payload;
      store.commit("Recommend/SET_CHECKLIST_DATAS", payload);
    },
    SET_IMPACT_ASSESSMENT: (state: any, payload) => {
      state.impactAssessment = payload;
    },
    SET_IMPORTANCE_ASSESSMENT: (state: any, payload) => {
      state.importanceAssessment = payload;
    },
    SET_EFFORT_ASSESSMENT: (state: any, payload) => {
      state.effortAssessment = payload;
    },
    SET_COST_ASSESSMENT: (state: any, payload) => {
      state.costAssessment = payload;
    },
    REMOVE_CHECK_LIST_QUESTION_ATTACHMENT: (state: any, payload) => {
      const { selectedQuestions } = payload;
      state.arrayChecklistOrigin.forEach((item: IAssessmentChecklistItem) => {
        if (selectedQuestions?.includes(item.checklistItemOrder)) {
          item.checklistItemAttachments = [];
          item.additionalData = [];
        }
      });
      state.arrayChecklistAllOrigin.forEach(
        (item: IAssessmentChecklistItem) => {
          if (selectedQuestions?.includes(item.checklistItemOrder)) {
            item.checklistItemAttachments = [];
            item.additionalData = [];
          }
        },
      );
      state.objectChecklistOrigin[state.activeCategory].forEach((item) => {
        if (selectedQuestions?.includes(item.checklistItemOrder)) {
          item.checklistItemAttachments = [];
          item.additionalData = [];
        }
      });
    },
    SET_CHECKLIST_OVERVIEW: (state, { type, data }) => {
      if (type === "exposuresCard") {
        state.overviewCardData.exposuresCard.criticalNumber =
          data.checklistItemsComplianceLt || 0;
        state.overviewCardData.exposuresCard.totalNumber =
          data.checklistItemsComplianceLt || 0;
      }

      if (type === "completionCard") {
        typeof data.checklistCompletion === "number" &&
          (state.overviewCardData.completionCard.checklistCompletion =
            data.checklistCompletion);

        typeof data.checklistCompletionMax === "number" &&
          (state.overviewCardData.completionCard.checklistCompletionMax =
            data.checklistCompletionMax);

        typeof data.checklistCompletionPcnt === "number" &&
          (state.overviewCardData.completionCard.checklistCompletionPcnt =
            data.checklistCompletionPcnt);

        typeof data.checklistScore === "number" &&
          (state.overviewCardData.completionCard.checklistScore =
            data.checklistScore);

        typeof data.checklistScoreMax === "number" &&
          (state.overviewCardData.completionCard.checklistScoreMax =
            data.checklistScoreMax);

        typeof data.checklistScorePcnt === "number" &&
          (state.overviewCardData.completionCard.checklistScorePcnt =
            data.checklistScorePcnt);
      }

      if (type === "detailsCard") {
        state.overviewCardData.detailsCard = data;
        state.overviewCardData.detailsCard.checklistStatus =
          assessmentStatus.inProgress;
      }
    },
    SET_RECOMMENDATIONS: (state, recommendations) => {
      state.recommendations = recommendations;
    },
    SET_IS_SHOW_EXCLUDED: (state: any, isShowExcluded: boolean) => {
      localStorage.setItem(
        localStorageKey.isShowExcluded,
        JSON.stringify(isShowExcluded),
      );
      state.getIsShowExcluded = isShowExcluded;
    },
    CLEAR_ASSESSMENT_INPUT: (state) => {
      state.loading = true;
      state.categories = [];
    },
    SET_RECENT_SEARCHES: (state, { listRecentSearches, searchTypeId }) => {
      if (!searchTypeId) return;

      if (!listRecentSearches || !listRecentSearches.length) {
        state.listRecentSearches[searchTypeId] = {} as any;
        return;
      }

      state.listRecentSearches[searchTypeId] = listRecentSearches[0];
    },
    REORDER_LIST_TEMPLETE: (state, { oldIndex, newIndex }) => {
      const listTemplate = state.listTemplate;
      const item = listTemplate.splice(oldIndex, 1)[0];
      listTemplate.splice(newIndex, 0, item);
      state.listTemplate = listTemplate;
    },
    SET_LIST_TEMPLATE_DETAIL: (state, listTemplateDetail) => {
      state.listTemplateDetail = listTemplateDetail[0];
    },
    UPDATE_TOTAL_COUNT_TEMPLATE: (state, { templateId, total }) => {
      const listTemplate = state.listTemplate;
      listTemplate.forEach((item) => {
        if (item.templateId === templateId) {
          item.total = total;
        }
      });
      state.listTemplate = listTemplate;
    },

    SET_CHECKLIST_CURRENT_CHECKLIST_ADVANCED: (state, payload) => {
      state.currentChecklistAdvanced = payload;
    },

    UPDATE_CHECKLIST_ASSESSMENT_BY_CHECKLISTID: (
      state,
      checklistAssessment,
    ) => {
      state.checklistAssessment = state.checklistAssessment.map((item) => {
        if (item.checklistId === checklistAssessment.checklistId) {
          const checklistItem = item.checklistItem?.map((historyItem) => {
            if (historyItem.checklistId === checklistAssessment.checklistId) {
              return {
                ...historyItem,
                checklistDateReporting:
                  checklistAssessment.checklistDateReporting,
              };
            }
            return historyItem;
          });
          return {
            ...item,
            checklistDateReporting: checklistAssessment.checklistDateReporting,
            checklistItem,
          };
        }
        return item;
      });
    },
  },

  actions: {
    fetchChecklistByChecklistId: async (_, checklistId) => {
      try {
        const res = await getChecklist(checklistId);
        return res.data.data;
      } catch (error: any) {
        showErrorAPI(error, Assessment.checklistRename);
      }
    },
    resetAssessment: ({ commit }) => {
      commit("SET_CHECKLIST_ORIGIN", []);
      commit("SET_CHECKLIST_ALL", []);
      commit("SET_CHECKLIST_ALL_ORIGIN", []);
    },
    // Store CATEGORY:
    fetchCategories: async ({ commit }, { checklistId, reload }) => {
      try {
        const res = await getAssessmentCategories(checklistId);
        const categories: ICategories[] = get(
          res,
          "data.data.checklistCategories",
          [],
        );
        const activeCategory: string =
          categories[0] && categories[0].checklistItemCategoryId
            ? categories[0].checklistItemCategoryId
            : "";

        commit("SET_CURRENT_CATEGORY", categories);
        reload && commit("SET_CURRENT_ACTIVE_CATEGORY", activeCategory);
      } catch (error: any) {
        if (error && error.data) {
          showErrorAPI(error, Assessment.getCategories);
        }
      }
    },
    getCheckListIdMetricsCountCompliance: async ({ commit }, checklistId) => {
      try {
        const res = await getCheckListIdMetricsCountCompliance(checklistId);
        if (res?.status === successStatusCodes.OK) {
          commit("SET_CHECKLIST_OVERVIEW", {
            type: "exposuresCard",
            data: res.data.data,
          });

          return res;
        }
      } catch (error: any) {
        showErrorAPI(error, Assessment.checkListIdMetricsCountCompliance);
      }
    },

    getCheckListOverviewDetailCard: async ({ commit }, checklistId) => {
      try {
        const res = await getDetailFromCheckListId(checklistId);
        if (res?.status === successStatusCodes.OK) {
          const data = get(res, "data.data", {}) as IChecklistInfoDetail;
          const value = {
            ...data,
            status: assessmentStatus.inProgress,
          };

          commit("SET_CHECKLIST_INFO_DETAIL", { ...data, checklistId });
          commit("SET_CHECKLIST_OVERVIEW", {
            type: "detailsCard",
            data: value,
          });
        }
      } catch (error: any) {
        showErrorAPI(error, Assessment.getDetailFromCheckListId);
      }
    },

    getChecklistMetricScoreCompletion: async ({ commit }, checklistId) => {
      const res = await getMetricFromChecklistId(checklistId);
      if (res?.status === successStatusCodes.OK) {
        const value = { ...res.data.data };
        commit("SET_CHECKLIST_OVERVIEW", {
          type: "completionCard",
          data: value,
        });
      }
    },

    getAllScoreDetail: async ({ state }) => {
      try {
        const checklistIds: number[] = [];
        state.checklistAssessment.map((item) => {
          item.checklistItem?.map((itemCl) => {
            checklistIds.push(itemCl.checklistId);
          });
        });
        const results = await Promise.all(
          [...new Set(checklistIds)].map((id) => getMetricFromChecklistId(id)),
        );
        state.scoreDetail = results.map((item) => item.data.data);
      } catch (error: any) {
        showErrorAPI(error, Checklist.getChecklistToItemMetric);
      }
    },

    changeActiveCategory: ({ commit }, activeCategory) => {
      commit("SET_CURRENT_ACTIVE_CATEGORY", activeCategory);
    },

    changeRefreshCategory: ({ commit }, activeCategory) => {
      commit("SET_REFRESH_CATEGORY", activeCategory);
    },

    // Store CHECKLIST.
    fetchChecklistByCategory: async (
      { commit, state },
      {
        checklistIdParam,
        showMasterItem,
        includeExcluded,
        isForceUpdate = false,
        itemRemoved = null,
      },
    ) => {
      state.loading = true;
      const activeCategory = state.activeCategory;
      const categories = state.categories;

      try {
        const res = await getAssessmentChecklists(
          activeCategory,
          checklistIdParam,
          showMasterItem,
          includeExcluded,
        );
        const {
          data: {
            data: { checklistItems, ...checklistDetail },
          },
        } = res;
        const checklist: any[] = checklistItems ?? [];
        const masterAddable: any = get(res, "data.data.masterItemsAddable", []);

        if (masterAddable.length > 0) {
          const questionMaster = initialChecklistMaster(masterAddable);
          checklist.push(...questionMaster);
        }

        const currentOrg = store.state.Org.currentOrg;
        const orgSetup = store.state.SetupWizard.questions[currentOrg.id];
        const checklistSorted = initialChecklistByCategory(
          checklist,
          categories,
          orgSetup,
        );

        const checklistUpdated = initialChecklistOrigin(
          checklist,
          checklistSorted,
          orgSetup,
        );
        commit("SET_CHECKLIST_CATEGORY", {
          checklist: [...checklistSorted],
          category: activeCategory,
        });
        commit("SET_CHECKLIST_ORIGIN", {
          checklistUpdated,
          isForceUpdate,
          itemRemoved,
        });
        commit("SET_CHECKLIST_DETAIL", checklistDetail);
      } catch (error: any) {
        console.error("error", error);
        commit("SET_CHECKLIST_DETAIL", {});
        commit("SET_CHECKLIST_CATEGORY", {
          checklist: [],
          category: activeCategory,
        });
        commit("SET_CHECKLIST_ORIGIN", []);
        if (error && error.data) {
          showErrorAPI(error, Assessment.getChecklists);
        }
      }
    },

    // Update checklist after duplicate.
    updateChecklistAfterDuplicate: async (
      { commit, state },
      {
        checklistItems,
      }: {
        checklistItems: IAssessmentChecklistItem[];
      },
    ) => {
      if (!checklistItems || checklistItems.length === 0) return;

      const categories = state.categories;
      const activeCategory = state.activeCategory;
      const checklist = state.arrayChecklistOrigin
        ? JSON.parse(JSON.stringify(state.arrayChecklistOrigin))
        : [];

      let checklistByCategory = checklist.filter(
        (item) => item.checklistItemCategoryId === activeCategory,
      );

      checklistByCategory = checklistByCategory.map(
        ({ checklistChildren: _checklistChildren, ...rest }) => rest,
      );

      checklistByCategory.push(...checklistItems);

      const currentOrg = store.state.Org.currentOrg;
      const orgSetup = store.state.SetupWizard.questions[currentOrg.id];
      const checklistSorted = initialChecklistByCategory(
        checklistByCategory,
        categories,
        orgSetup,
      );

      const checklistUpdated = initialChecklistOrigin(
        checklistByCategory,
        checklistSorted,
        orgSetup,
      );

      commit("SET_CHECKLIST_CATEGORY", {
        checklist: [...checklistSorted],
        category: activeCategory,
      });

      commit("SET_CHECKLIST_ORIGIN", { checklistUpdated });
    },

    resetChecklist: async ({ commit, state }) => {
      state.loading = true;
      const activeCategory = state.activeCategory;
      await commit("SET_CHECKLIST_CATEGORY", {
        checklist: [],
        category: activeCategory,
      });
    },

    getTemplate: async ({ commit }) => {
      try {
        const res = await getTemplate();
        const listTemplate = get(res, "data.data", []);
        commit("SET_LIST_TEMPLATE", listTemplate);
      } catch (error) {
        commit("SET_LIST_TEMPLATE", []);
      }
    },

    getTemplateDetail: async ({ commit }, templateId) => {
      try {
        const res = await getTemplateDetail(templateId);
        const listTemplateDetail: any = get(res, "data.data.templates", []);

        commit("SET_LIST_TEMPLATE_DETAIL", listTemplateDetail);

        if (listTemplateDetail.length > 0) {
          commit("UPDATE_TOTAL_COUNT_TEMPLATE", {
            templateId,
            total: listTemplateDetail[0].itemCount,
          });
        }
      } catch (error) {
        showErrorAPI(error, Assessment.getTemplateDetail);
      }
    },

    updateChecklistId: async ({ commit }, checklistId) => {
      commit("SET_CURRENT_CHECKLIST_ID", checklistId);
    },

    fetchAssessmentQuestionTypes: async (
      { commit },
      checklistContextIds = "",
    ) => {
      try {
        const res = await getInputComplianceTypes(
          checklistContextIds !== "" ? checklistContextIds : "",
          true,
        );

        if (res.data?.data?.complianceTypes) {
          if (checklistContextIds == "clr")
            commit("SET_ASS_QUES_TYPES_CLR", res.data?.data?.complianceTypes);
          else commit("SET_ASS_QUES_TYPES", res.data?.data?.complianceTypes);
        }
        return res.data?.data?.complianceTypes;
      } catch (error) {
        showErrorAPI(error, Assessment.getInputComplianceTypes);
      }
    },

    fetchChecklistAll: async ({ commit, state }, checklistId) => {
      state.loading = true;
      const categories = state.categories;
      try {
        state.loadingSearch = true;
        const res = await getChecklistAll(checklistId);
        const checklist: any[] = get(res, "data.data.checklistItems", []);

        const currentOrg = store.state.Org.currentOrg;
        const orgSetup = store.state.SetupWizard.questions[currentOrg.id];
        const checklistAllSorted = initialChecklistByCategory(
          checklist,
          categories,
          orgSetup,
        );

        const checklistAllUpdated = initialChecklistOrigin(
          checklist,
          checklistAllSorted,
          orgSetup,
        );

        commit("SET_CHECKLIST_ALL", checklistAllSorted);
        commit("SET_CHECKLIST_ALL_ORIGIN", checklistAllUpdated);
        state.loadingSearch = false;
      } catch (error) {
        state.loading = false;
        state.loadingSearch = false;
        commit("SET_CHECKLIST_ALL", []);
        commit("SET_CHECKLIST_ALL_ORIGIN", []);
      } finally {
        state.loading = false;
      }
    },

    getUserUploadFile: async (_, userId) => {
      try {
        return await getUserUploadFile(userId);
      } catch (error) {
        showErrorAPI(error, Assessment.getUserUploadFile);
      }
    },

    changeIsHideComplete: ({ commit }, isHideComplete) => {
      commit("SET_IS_HIDE_COMPLETE", isHideComplete);
    },
    updateShowMasterItems: ({ commit }, showMasterItems) => {
      commit("SET_SHOW_MASTER_ITEMS", showMasterItems);
    },
    updateAssessmentView: ({ commit }, assessmentView) => {
      commit("SET_ASSESSMENT_VIEW", assessmentView);
    },
    updateAnswer: async ({ state }, payload) => {
      const { checklistItemId, answer, type, isGlobalSearch } = payload;
      if (
        state.checklistInforDetail?.checklistStatusId ===
        checklistStatusId.completed
      ) {
        return;
      }

      const data = await store.dispatch("Assessment/updateAnswerChecklist", {
        checklistItemId,
        answer,
        type,
        isGlobalSearch,
      });

      return data;
    },

    resetChecklistUpdateType: async ({ state }) => {
      state.checklistUpdateType = "";
    },

    setFilters: async ({ state }, filters) => {
      state.filters = filters;
    },

    updateChecklstAllItem: ({ state }, itemUpdate: any) => {
      let parentIndex = -1,
        childIndex = -1;
      if (!itemUpdate.checklistItemId) return;
      state.checklistAll.some((item: any, index) => {
        if (item.checklistItemId === itemUpdate.checklistItemId) {
          parentIndex = index;
          return true;
        }
        if (item.checklistChildren && item.checklistChildren.length > 0) {
          item.checklistChildren.some((child: any, childIdx) => {
            if (child.checklistItemId === itemUpdate.checklistItemId) {
              parentIndex = index;
              childIndex = childIdx;
              return true;
            }
            return false;
          });
        }
        return false;
      });
      if (parentIndex >= 0) {
        if (childIndex >= 0) {
          state.checklistAll[parentIndex].checklistChildren[childIndex] =
            itemUpdate;
        } else {
          state.checklistAll[parentIndex] = itemUpdate;
        }
      }
    },

    updateAnswerChecklist: async (
      { state },
      {
        checklistItemId,
        answer,
        type = ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_TYPE_VALUE,
        isGlobalSearch = false,
      },
    ) => {
      try {
        state.checklistUpdateType = type;
        let checklistItem = state.arrayChecklistOrigin.find(
          (item) => item.checklistItemId === checklistItemId,
        );
        let checklistAll = state.arrayChecklistAllOrigin.find(
          (item) => item.checklistItemId === checklistItemId,
        );

        if (checklistItem) {
          checklistItem = await updateChecklistAnswer(
            state.assessmentQuestionTypes,
            state.currentChecklistId,
            checklistItem,
            answer,
            type,
          );

          if (!checklistItem) return false;
          state.objectChecklistOrigin[state.activeCategory].some((item) => {
            if (item.checklistItemId === checklistItemId && checklistItem) {
              item = checklistItem;
              return true;
            }
            return false;
          });
        } else {
          if (isGlobalSearch) {
            checklistItem = await updateChecklistAnswer(
              state.assessmentQuestionTypes,
              state.currentChecklistId,
              checklistAll,
              answer,
              type,
            );

            state.objectChecklistOrigin[state.activeCategory].some((item) => {
              if (item.checklistItemId === checklistItemId && checklistItem) {
                item = checklistItem;
                return true;
              }
              return false;
            });
          } else return checklistItem;
        }

        store.dispatch("Assessment/fetchCategories", {
          checklistId: state.currentChecklistId,
          reload: false,
        });

        if (checklistAll) {
          if (checklistItem) {
            checklistAll = checklistItem;
          } else {
            checklistAll = await updateChecklistAnswer(
              state.assessmentQuestionTypes,
              state.currentChecklistId,
              checklistAll,
              answer,
              type,
            );
          }

          store.dispatch(
            "Assessment/getCheckListIdMetricsCountCompliance",
            state.currentChecklistId,
          );

          store.dispatch(
            "Assessment/getCheckListOverviewDetailCard",
            state.currentChecklistId,
          );

          store.dispatch(
            "Assessment/getChecklistMetricScoreCompletion",
            state.currentChecklistId,
          );

          store.dispatch(
            "Assessment/fetchCheckListIdMetricsCompletion",
            state.currentChecklistId,
          );
        } else return checklistAll;
      } catch (error: any) {
        showErrorAPI(error, Assessment.postAnswerQuestion);
      }
    },

    fetchCheckListIdMetricsCompletion: async ({ commit }, checklistId) => {
      try {
        const res = await getCheckListIdMetricsCompletion(checklistId);
        const data = get(res, "data.data", {}) as IChecklistMetricsCompletion;
        commit("SET_CHECKLIST_METRICS_COMPLETION", data);
        commit("SET_CHECKLIST_OVERVIEW", { type: "completionCard", data });
      } catch (error: any) {
        showErrorAPI(error, Assessment.checkListIdMetricsCompletion);
      }
    },

    fetchInfoDetailByChecklistId: async ({ commit }, checklistId) => {
      try {
        const res = await getDetailFromCheckListId(checklistId);
        const data = get(res, "data.data", {}) as IChecklistInfoDetail;

        commit("SET_CHECKLIST_INFO_DETAIL", { ...data, checklistId });
      } catch (error: any) {
        showErrorAPI(error, Assessment.getDetailFromCheckListId);
      }
    },

    fetchChecklistAssessmentDetail: ({ commit, state }) => {
      // Get Checklist Assessment Score.
      const checklistAssessment: IAssessmentDetail[] =
        state.checklistAssessment;
      checklistAssessment.forEach(async (checklist) => {
        checklist.scoreDetail = await getChecklistAssessmentScore();

        checklist.checklistAssessmentHistory?.forEach(async (item) => {
          if (item.checklistId === checklist.checklistId)
            item.scoreDetail = checklist.scoreDetail;
          else item.scoreDetail = await getChecklistAssessmentScore();
        });
      });
      commit("SET_CHECKLIST_ASSESSMENT", checklistAssessment);
    },

    updateStatusAssessmentHistory: async ({ commit, state }, payload) => {
      const checklistAssessment: IAssessmentDetail[] =
        state.checklistAssessment;
      const { checklistId, data } = payload;
      let res: any = null;
      if (!data) {
        res = await getCheckListStatusDetails(checklistId);
      }

      const checklistAssessment1 = checklistAssessment.map((checklist) => {
        const his = checklist.checklistAssessmentHistory?.map((item) => {
          if (item?.checklistId === checklistId) {
            return {
              ...item,
              checklistStatus: res
                ? res.data.data.checklistStatus
                : data.checklistStatus,
              checklistStatusDate: res
                ? res.data.data.checklistStatusDate
                : data.checklistStatusDate,
              checklistStatusId: res
                ? res.data.data.checklistStatusId
                : data.checklistStatusId,
              checklistStatusNotes: res
                ? res.data.data.checklistStatusNotes
                : data.checklistStatusNotes,
              statusDetails: res ? res.data.data : data,
            };
          } else return item;
        });
        return { ...checklist, checklistAssessmentHistory: his };
      });

      commit("SET_CHECKLIST_ASSESSMENT", checklistAssessment1);
    },

    fetchChecklistAssessment: async ({ commit }) => {
      try {
        const res = await getAllChecklist();
        const checklist: IAssessmentDetail[] = get(res, "data.data", []);
        if (!checklist || checklist.length === 0) {
          commit("SET_CHECKLIST_ASSESSMENT", checklist);
          return;
        }

        await Promise.all(
          checklist.map(async (e, index) => {
            const res = await getCheckListStatusDetails(e.checklistId);
            checklist[index].statusDetails = res.data.data;
          }),
        );

        const data = await processChecklistAssessmentData(checklist);
        commit("SET_CHECKLIST_ASSESSMENT", data);
        return res;
      } catch (error: any) {
        showErrorAPI(error, Assessment.checklistStatus);
        return null;
      }
    },

    updateChecklistStatusId: async (_, { checklistId, params }) => {
      await putChecklistStatus(checklistId, params);
    },

    updateChecklistStatus: async ({ state }, { checklistId, params }) => {
      try {
        state.checklistAssessment.forEach((item, index) => {
          if (item?.checklistId === checklistId) {
            const newChecklist = {
              ...item,
              ...params,
            };
            const checklistItem: any = item.checklistItem;
            checklistItem[0] = newChecklist;
            state.checklistAssessment[index] = {
              ...newChecklist,
              checklistItem,
            };
          } else {
            if (item.checklistItem && item.checklistItem.length > 0) {
              item.checklistItem.forEach((itemP, idxP) => {
                if (itemP?.checklistId === checklistId) {
                  itemP = {
                    ...itemP,
                    ...params,
                  };
                  const checklistItem: any = item.checklistItem;
                  checklistItem[idxP] = itemP;
                  state.checklistAssessment[index] = {
                    ...item,
                    checklistItem,
                  };
                }
              });
            }
          }
        });
        return true;
      } catch (error) {
        showErrorAPI(error, Assessment.checklistRename);
        return null;
      }
    },

    updateChecklistRename: async (
      { state, commit },
      { checklistId, params },
    ) => {
      try {
        const res = await putChecklistRename(checklistId, params);
        const data = get(res, "data.data", {});
        commit("SET_CHECKLIST_DETAIL", data);
        store.dispatch("Assessment/updateChecklistStatus", {
          checklistId,
          params: { ...data },
        });
        state.checklistAssessment.forEach((item, index) => {
          if (item?.checklistId === checklistId) {
            state.checklistAssessment[index].checklistName =
              params?.checklistName;
            if (params?.checklistDescription !== undefined) {
              state.checklistAssessment[index].checklistDescription =
                params?.checklistDescription;
            }
            state.checklistAssessment[index].checklistDateEdited =
              data.checklistDateEdited;
            return true;
          }
          if (item.checklistItem && item.checklistItem.length > 0) {
            item.checklistItem.forEach((itemP, idxP) => {
              if (itemP?.checklistId === checklistId) {
                itemP = {
                  ...itemP,
                  checklistName: params?.checklistName,
                  checklistDateEdited: data.checklistDateEdited,
                };
                if (params?.checklistDescription !== undefined) {
                  itemP = {
                    ...itemP,
                    checklistDescription: params?.checklistDescription,
                    checklistDateEdited: data.checklistDateEdited,
                  };
                }
                const checklistItem: any = item.checklistItem;
                checklistItem[idxP] = itemP;
                state.checklistAssessment[index] = {
                  ...item,
                  checklistItem,
                };
              }
            });
          }
        });
        return true;
      } catch (error) {
        showErrorAPI(error, Assessment.checklistRename);
        return null;
      }
    },
    updateCheckListItem: async ({ commit }, payload) => {
      const { checklistItemId, data, type } = payload;
      commit("UPDATE_CHECKLIST_ITEM", { checklistItemId, data, type });
    },
    updateListCheckListItems: async ({ commit }, payload) => {
      commit("UPDATE_LIST_CHECKLIST_ITEMS", payload);
    },
    updateCheckListItems: async ({ commit }, payload) => {
      const { checklistItemIds, data, type } = payload;
      commit("UPDATE_CHECKLIST_ITEMS", { checklistItemIds, data, type });
    },
    getAttachment: async (_, attachmentId: number) => {
      const res = await handleGetAttachment(attachmentId);
      return res;
    },
    fetchImportanceAssessment: async ({ commit }) => {
      try {
        const res = await getImportanceAssessment();
        const data = get(res, "data.data.importance", {});
        commit("SET_IMPORTANCE_ASSESSMENT", data);
      } catch (error) {
        showErrorAPI(error, Assessment.getImportanceAssessment);
      }
    },
    fetchImpactAssessment: async ({ commit }) => {
      try {
        const res = await getImpactAssessment();
        const data = get(res, "data.data.impact", {});
        commit("SET_IMPACT_ASSESSMENT", data);
      } catch (error) {
        showErrorAPI(error, Assessment.getImpactAssessment);
      }
    },
    fetchEffortAssessment: async ({ commit }) => {
      try {
        const res = await getEffortAssessment();
        const data = get(res, "data.data.effort", {});
        commit("SET_EFFORT_ASSESSMENT", data);
      } catch (error) {
        showErrorAPI(error, Assessment.getEffortAssessment);
      }
    },
    fetchCostAssessment: async ({ commit }) => {
      try {
        const res = await getCostAssessment();
        const data = get(res, "data.data.cost", {});
        commit("SET_COST_ASSESSMENT", data);
      } catch (error) {
        showErrorAPI(error, Assessment.getCostAssessment);
      }
    },
    updateMasterItems: async (
      _,
      { checklistId, masterItemIds, activeCategoryId },
    ) => {
      await addItemFromMaster(checklistId, masterItemIds, activeCategoryId);
    },
    downloadAttachments: async (
      _,
      { attachmentIds, passkey, isVendorRequest },
    ) => {
      const fnDownload = async (id: number) => {
        let res;
        if (isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
          res = await getRequestAssessmentAttachment(id);
        } else {
          if (isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
            res = await getRequestVendorAssessmentAttachment(id);
          } else {
            res = await handleGetAttachment(id);
          }
        }
        if (res.status === successStatusCodes.OK) {
          const fileDecrypted = await decryptFileBase64(res.data.data, passkey);

          return utilities.downloadBase64File(
            fileDecrypted.fileName,
            fileDecrypted.file,
            fileDecrypted.fileMimeTypeDetected,
          );
        }
      };
      try {
        await Promise.all(attachmentIds.map((id: number) => fnDownload(id)));
        return true;
      } catch (e) {
        showErrorAPI(e, Assessment.getAttachment);
        return false;
      }
    },
    removeAttachments: async ({ commit }, { attachmentIds }) => {
      try {
        commit("");
        await deleteFiles(attachmentIds);
        return true;
      } catch (e) {
        showErrorAPI(e, Assessment.checklistAttachments);
        return false;
      }
    },
    fetchSuggestedActionData: async ({ state, commit }: any) => {
      try {
        const res = await getChecklistGroupTemplateMetrics(
          state.currentChecklistId,
        );
        const recommendationsNumber = res.data.data.groupMetrics.length || 0;
        commit("SET_RECOMMENDATIONS", recommendationsNumber);
      } catch (error) {
        showErrorAPI(error, Assessment.getChecklistGroupTemplateMetrics);
      }
    },
    createOrUpdateAssessmentTemplate: async (
      { state, commit }: any,
      payload: {
        checklistId: number;
        templateId: number;
        data: {
          templateId?: number;
          templateName: string;
          templateVersion?: string;
          templateOrder?: number;
          templateDescription?: string;
          templateNotes?: string;
          orgId?: number;
        };
      },
    ) => {
      const { templateId, checklistId, data } = payload || {};
      try {
        if (!templateId) {
          const res = await postChecklistTemplate({ checklistId, data });
          const template = get(res, "data.data", {});
          commit("SET_LIST_TEMPLATE", [...state.listTemplate, template]);
        } else {
          const res = await putChecklistTemplate({ checklistId, templateId });
          const template = get(res, "data.data", {});
          commit("SET_LIST_TEMPLATE", [
            ...state.listTemplate.filter(
              (item: any) => item.templateId === template.templateId,
            ),
            template,
          ]);
        }
        showSuccessToast(
          !templateId
            ? getComponentUiText(
                "app-assess-assessment-modal-create-assessment-template-post-success",
              )
            : getComponentUiText(
                "app-assess-assessment-modal-create-assessment-template-update-success",
              ),
        );
        return true;
      } catch (error) {
        showErrorAPI(
          error,
          !templateId
            ? Assessment.postChecklistTemplate
            : Assessment.putChecklistTemplate,
        );
        return false;
      }
    },
    postRecentSearchInput: async (_, { searchTypeId, searchData }) => {
      // const checkValueSearch = state.listRecentSearches
      //   ?.find((item) => item.searchTypeId === searchTypeId)
      //   ?.searchHistory.some(
      //     (item) => item.searchData.text === searchData.text,
      //   );

      try {
        await userService.postRecentSearches(searchTypeId, searchData);
      } catch (error) {
        showErrorAPI(error, UserRoute.apiRecentSearches);
      }
    },

    getRecentSearches: async ({ commit }, { searchTypeId }) => {
      try {
        const res = await userService.getRecentSearches(searchTypeId);
        const listRecentSearches = get(res, "data.data.searchTypeIds", []);
        commit("SET_RECENT_SEARCHES", { listRecentSearches, searchTypeId });
      } catch (error) {
        showErrorAPI(error, UserRoute.getRecentSearches);
      }
    },
    clearRecentSearch: async ({ commit }, { searchTypeId }) => {
      try {
        const res = await userService.deleteRecentSearches(searchTypeId);
        if (res.status === successStatusCodes.OK) {
          commit("SET_RECENT_SEARCHES", {
            listRecentSearches: [],
            searchTypeId,
          });
        }
      } catch (error) {
        showErrorAPI(error, UserRoute.apiRecentSearches);
      }
    },
  },
};

export default assessmentModule;
